import { UI_TO_CMS_MAP } from '../cms/cmsLocaleConstants';
import { ExperimentId } from './experimentsConstants';

export const LOCALE_EXPERIMENT_ID_TO_LOCALE_CODE = {
    [ExperimentId.appLocaleGerman]: UI_TO_CMS_MAP.de,
    [ExperimentId.appLocaleChineseSimplified]: UI_TO_CMS_MAP.zh,
    [ExperimentId.appLocaleRussian]: UI_TO_CMS_MAP.ru,
    [ExperimentId.appLocalePolish]: UI_TO_CMS_MAP.pl,
    [ExperimentId.appLocaleJapanese]: UI_TO_CMS_MAP.ja,
    [ExperimentId.appLocaleDutch]: UI_TO_CMS_MAP.nl,
    [ExperimentId.appLocaleItalian]: UI_TO_CMS_MAP.it,
    [ExperimentId.appLocaleKorean]: UI_TO_CMS_MAP.ko,
} as const;

// Add released locales here once they're no longer behind an experiment
export const DEFAULT_RELEASED_LOCALE_CODES = [
    UI_TO_CMS_MAP.en,
    UI_TO_CMS_MAP.es,
    UI_TO_CMS_MAP.fr,
    UI_TO_CMS_MAP.pt,
] as const;

export type LocaleExperimentId = keyof typeof LOCALE_EXPERIMENT_ID_TO_LOCALE_CODE;

export const LOCALE_EXPERIMENT_IDS = Object.keys(LOCALE_EXPERIMENT_ID_TO_LOCALE_CODE) as LocaleExperimentId[];

export const isLocaleExperimentId = (experimentId: string): experimentId is LocaleExperimentId =>
    Object.prototype.hasOwnProperty.call(LOCALE_EXPERIMENT_ID_TO_LOCALE_CODE, experimentId);
